import { render } from "./EpisodeMain.vue?vue&type=template&id=05670c60"
import script from "./EpisodeMain.vue?vue&type=script&lang=js"
export * from "./EpisodeMain.vue?vue&type=script&lang=js"

import "./EpisodeMain.vue?vue&type=style&index=0&id=05670c60&lang=css"

import exportComponent from "D:\\project\\survey-slp-house\\survey-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__